/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAnnouncementsRouteImport } from './routes/_authenticated/announcements'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedConnectRouteImport } from './routes/_authenticated/connect'
import { Route as AuthenticatedFeedbackRouteImport } from './routes/_authenticated/feedback'
import { Route as AuthenticatedGroupsRouteImport } from './routes/_authenticated/groups'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedPlansRouteImport } from './routes/_authenticated/plans'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedFeedbackReportIdRouteImport } from './routes/_authenticated/feedback.$reportId'
import { Route as AuthenticatedSettingsConnectedAppsRouteImport } from './routes/_authenticated/settings/connected-apps'
import { Route as AuthenticatedSettingsHolidaysRouteImport } from './routes/_authenticated/settings/holidays'
import { Route as AuthenticatedGroupsGroupIdIndexRouteImport } from './routes/_authenticated/groups.$groupId.index'
import { Route as AuthenticatedGroupsGroupIdCompaniesCompanyIdRouteImport } from './routes/_authenticated/groups.$groupId.companies.$companyId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnnouncementsRoute =
  AuthenticatedAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConnectRoute = AuthenticatedConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedbackRoute = AuthenticatedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsRoute = AuthenticatedGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlansRoute = AuthenticatedPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedbackReportIdRoute =
  AuthenticatedFeedbackReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthenticatedFeedbackRoute,
  } as any)
const AuthenticatedSettingsConnectedAppsRoute =
  AuthenticatedSettingsConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsHolidaysRoute =
  AuthenticatedSettingsHolidaysRouteImport.update({
    id: '/holidays',
    path: '/holidays',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedGroupsGroupIdIndexRoute =
  AuthenticatedGroupsGroupIdIndexRouteImport.update({
    id: '/$groupId/',
    path: '/$groupId/',
    getParentRoute: () => AuthenticatedGroupsRoute,
  } as any)
const AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute =
  AuthenticatedGroupsGroupIdCompaniesCompanyIdRouteImport.update({
    id: '/$groupId/companies/$companyId',
    path: '/$groupId/companies/$companyId',
    getParentRoute: () => AuthenticatedGroupsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/connect': typeof AuthenticatedConnectRoute
  '/feedback': typeof AuthenticatedFeedbackRouteWithChildren
  '/groups': typeof AuthenticatedGroupsRouteWithChildren
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/support': typeof AuthenticatedSupportRoute
  '/feedback/$reportId': typeof AuthenticatedFeedbackReportIdRoute
  '/settings/connected-apps': typeof AuthenticatedSettingsConnectedAppsRoute
  '/settings/holidays': typeof AuthenticatedSettingsHolidaysRoute
  '/groups/$groupId/': typeof AuthenticatedGroupsGroupIdIndexRoute
  '/groups/$groupId/companies/$companyId': typeof AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/connect': typeof AuthenticatedConnectRoute
  '/feedback': typeof AuthenticatedFeedbackRouteWithChildren
  '/groups': typeof AuthenticatedGroupsRouteWithChildren
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/support': typeof AuthenticatedSupportRoute
  '/': typeof AuthenticatedIndexRoute
  '/feedback/$reportId': typeof AuthenticatedFeedbackReportIdRoute
  '/settings/connected-apps': typeof AuthenticatedSettingsConnectedAppsRoute
  '/settings/holidays': typeof AuthenticatedSettingsHolidaysRoute
  '/groups/$groupId': typeof AuthenticatedGroupsGroupIdIndexRoute
  '/groups/$groupId/companies/$companyId': typeof AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/_authenticated/announcements': typeof AuthenticatedAnnouncementsRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/connect': typeof AuthenticatedConnectRoute
  '/_authenticated/feedback': typeof AuthenticatedFeedbackRouteWithChildren
  '/_authenticated/groups': typeof AuthenticatedGroupsRouteWithChildren
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/plans': typeof AuthenticatedPlansRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/feedback/$reportId': typeof AuthenticatedFeedbackReportIdRoute
  '/_authenticated/settings/connected-apps': typeof AuthenticatedSettingsConnectedAppsRoute
  '/_authenticated/settings/holidays': typeof AuthenticatedSettingsHolidaysRoute
  '/_authenticated/groups/$groupId/': typeof AuthenticatedGroupsGroupIdIndexRoute
  '/_authenticated/groups/$groupId/companies/$companyId': typeof AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/announcements'
    | '/audit'
    | '/connect'
    | '/feedback'
    | '/groups'
    | '/onboarding'
    | '/plans'
    | '/settings'
    | '/support'
    | '/feedback/$reportId'
    | '/settings/connected-apps'
    | '/settings/holidays'
    | '/groups/$groupId/'
    | '/groups/$groupId/companies/$companyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/announcements'
    | '/audit'
    | '/connect'
    | '/feedback'
    | '/groups'
    | '/onboarding'
    | '/plans'
    | '/settings'
    | '/support'
    | '/'
    | '/feedback/$reportId'
    | '/settings/connected-apps'
    | '/settings/holidays'
    | '/groups/$groupId'
    | '/groups/$groupId/companies/$companyId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/_authenticated/announcements'
    | '/_authenticated/audit'
    | '/_authenticated/connect'
    | '/_authenticated/feedback'
    | '/_authenticated/groups'
    | '/_authenticated/onboarding'
    | '/_authenticated/plans'
    | '/_authenticated/settings'
    | '/_authenticated/support'
    | '/_authenticated/'
    | '/_authenticated/feedback/$reportId'
    | '/_authenticated/settings/connected-apps'
    | '/_authenticated/settings/holidays'
    | '/_authenticated/groups/$groupId/'
    | '/_authenticated/groups/$groupId/companies/$companyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/announcements': {
      id: '/_authenticated/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthenticatedAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect': {
      id: '/_authenticated/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof AuthenticatedConnectRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedback': {
      id: '/_authenticated/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthenticatedFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups': {
      id: '/_authenticated/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthenticatedGroupsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/plans': {
      id: '/_authenticated/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthenticatedPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedback/$reportId': {
      id: '/_authenticated/feedback/$reportId'
      path: '/$reportId'
      fullPath: '/feedback/$reportId'
      preLoaderRoute: typeof AuthenticatedFeedbackReportIdRouteImport
      parentRoute: typeof AuthenticatedFeedbackRoute
    }
    '/_authenticated/settings/connected-apps': {
      id: '/_authenticated/settings/connected-apps'
      path: '/connected-apps'
      fullPath: '/settings/connected-apps'
      preLoaderRoute: typeof AuthenticatedSettingsConnectedAppsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/holidays': {
      id: '/_authenticated/settings/holidays'
      path: '/holidays'
      fullPath: '/settings/holidays'
      preLoaderRoute: typeof AuthenticatedSettingsHolidaysRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/groups/$groupId/': {
      id: '/_authenticated/groups/$groupId/'
      path: '/$groupId'
      fullPath: '/groups/$groupId/'
      preLoaderRoute: typeof AuthenticatedGroupsGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedGroupsRoute
    }
    '/_authenticated/groups/$groupId/companies/$companyId': {
      id: '/_authenticated/groups/$groupId/companies/$companyId'
      path: '/$groupId/companies/$companyId'
      fullPath: '/groups/$groupId/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedGroupsGroupIdCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedGroupsRoute
    }
  }
}

interface AuthenticatedFeedbackRouteChildren {
  AuthenticatedFeedbackReportIdRoute: typeof AuthenticatedFeedbackReportIdRoute
}

const AuthenticatedFeedbackRouteChildren: AuthenticatedFeedbackRouteChildren = {
  AuthenticatedFeedbackReportIdRoute: AuthenticatedFeedbackReportIdRoute,
}

const AuthenticatedFeedbackRouteWithChildren =
  AuthenticatedFeedbackRoute._addFileChildren(
    AuthenticatedFeedbackRouteChildren,
  )

interface AuthenticatedGroupsRouteChildren {
  AuthenticatedGroupsGroupIdIndexRoute: typeof AuthenticatedGroupsGroupIdIndexRoute
  AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute: typeof AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute
}

const AuthenticatedGroupsRouteChildren: AuthenticatedGroupsRouteChildren = {
  AuthenticatedGroupsGroupIdIndexRoute: AuthenticatedGroupsGroupIdIndexRoute,
  AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute:
    AuthenticatedGroupsGroupIdCompaniesCompanyIdRoute,
}

const AuthenticatedGroupsRouteWithChildren =
  AuthenticatedGroupsRoute._addFileChildren(AuthenticatedGroupsRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsConnectedAppsRoute: typeof AuthenticatedSettingsConnectedAppsRoute
  AuthenticatedSettingsHolidaysRoute: typeof AuthenticatedSettingsHolidaysRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsConnectedAppsRoute:
    AuthenticatedSettingsConnectedAppsRoute,
  AuthenticatedSettingsHolidaysRoute: AuthenticatedSettingsHolidaysRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAnnouncementsRoute: typeof AuthenticatedAnnouncementsRoute
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedConnectRoute: typeof AuthenticatedConnectRoute
  AuthenticatedFeedbackRoute: typeof AuthenticatedFeedbackRouteWithChildren
  AuthenticatedGroupsRoute: typeof AuthenticatedGroupsRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedPlansRoute: typeof AuthenticatedPlansRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnnouncementsRoute: AuthenticatedAnnouncementsRoute,
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedConnectRoute: AuthenticatedConnectRoute,
  AuthenticatedFeedbackRoute: AuthenticatedFeedbackRouteWithChildren,
  AuthenticatedGroupsRoute: AuthenticatedGroupsRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedPlansRoute: AuthenticatedPlansRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
